import { FontWeightAndStyleValueEnum } from '../enums/FontWeightAndStyleValueEnum'
export function fontWeightAndStyleSwitcher(fontWeightAndStyle: string) {
  let weightAndStyle
  switch (fontWeightAndStyle) {
    case FontWeightAndStyleValueEnum.Bold: {
      weightAndStyle = {
        fontWeight: 'Bold',
        fontStyle: 'normal',
      }
      break
    }
    case FontWeightAndStyleValueEnum.BoldItalic: {
      weightAndStyle = {
        fontWeight: 'Bold',
        fontStyle: 'italic',
      }
      break
    }
    case FontWeightAndStyleValueEnum.Normal: {
      weightAndStyle = {
        fontWeight: 'normal',
        fontStyle: 'normal',
      }
      break
    }
    case FontWeightAndStyleValueEnum.Italic: {
      weightAndStyle = {
        fontWeight: 'normal',
        fontStyle: 'italic',
      }
      break
    }
    default:
      weightAndStyle = {
        fontWeight: 'normal',
        fontStyle: 'normal',
      }
  }
  return weightAndStyle
}
